import React, { useState } from 'react';
import { Preset, Text } from '@lux/text';
import { ArrowUpXS } from '@lux/icons';
import { FunctionColor } from '@lux/tokens';
import { Translate } from '@pegasus/translation';
import { VoucherPolicyContainer, VoucherPolicyHeading, VoucherPolicyContent, LeftAlignedText, SmallFont, } from './styles';
export const TncAndVoucherPolicy = () => {
    const [isVoucherPolicyCollapsed, setIsVoucherPolicyCollapsed] = useState(false);
    const toggleVoucherPolicy = () => setIsVoucherPolicyCollapsed(!isVoucherPolicyCollapsed);
    return (React.createElement(React.Fragment, null,
        React.createElement(LeftAlignedText, null,
            React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function80 },
                React.createElement(SmallFont, null,
                    React.createElement(Translate, { message: "voucherTerms", html: true })))),
        React.createElement(VoucherPolicyContainer, null,
            React.createElement(VoucherPolicyHeading, { isCollapsed: isVoucherPolicyCollapsed, onClick: toggleVoucherPolicy },
                React.createElement(Text, { preset: Preset.XS, bold: true, color: FunctionColor.function80 },
                    React.createElement(SmallFont, null,
                        React.createElement(Translate, { message: "voucherPolicyLink" })),
                    React.createElement(ArrowUpXS, { color: FunctionColor.function80 }))),
            !isVoucherPolicyCollapsed ? null : (React.createElement(VoucherPolicyContent, null,
                React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function80 },
                    React.createElement(SmallFont, null,
                        React.createElement(Translate, { message: "minimumVoucherDisclaimer" }))))))));
};
//# sourceMappingURL=component.js.map